import { MochiRadio } from '@autopass-web/mochi-component';

import styles from './mochi-radio-item.module.sass';

interface MochiRadioItemProps {
  onClick: () => void;
  id: string;
  isChecked: boolean;
  name: string;
  content?: React.ReactNode;
  label: string;
}

export const MochiRadioItem = ({
  onClick,
  label,
  id,
  isChecked,
  name,
  content,
}: MochiRadioItemProps) => {
  return (
    <div className={styles['radio-item']} onClick={onClick}>
      <div className={styles['top']}>
        <div className={styles['text']}>
          <p>{label}</p>
        </div>
        <MochiRadio isChecked={isChecked} ariaLabel={name} id={id} />
      </div>
      {content && isChecked && (
        <div className={styles['content']}>{content}</div>
      )}
    </div>
  );
};
